module.exports = __webpack_public_path__ + "static/media/thumbnail.4080d02b.jpg";